export const EndowmentEffect = {
    de: {
        title: "Mein Ticket - dein Preis?",
        description:
            "Am Bodensee findet bald das Seestadt Soundfestival statt: Einige besitzen Tickets, können aber nicht hingehen. Andere würden gern teilnehmen, haben aber keine Karte.",
        screens: {
            seller: {
                title: "Du bist Verkäufer: Du besitzt ein Ticket",
                text:
                    "Du hast vor einigen Monaten ein Ticket für das Seestadt Soundfestival für 80€ gekauft. Beim Blick in den Kalender merkst du jedoch, dass du einen wichtigen Termin übersehen hast. Daher entscheidest du dich nicht hinzugehen und möchtest deine Karte verkaufen.",
                inputLabel: "Für welchen Preis (in €) würdest du die Karte verkaufen?",
                placeholder: "Hier eingeben",
                validation: "Bitte gib einen ganzzahligen Betrag in vollen Euro (ohne Cent) an.",
                reasonLabel: "Begründe deine Entscheidung",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Schreibe hier deine Begründung..."
            },
            buyer: {
                title: "Du bist Käufer: Kartennachfrage",
                text:
                    "Deine Lieblingsband spielt beim Seestadt Soundfestival. Tickets sind ausverkauft. Ein Freund bietet ein Ticket zum Verkauf an.",
                inputLabel: "Das Ticket hat 80€ gekostet. Wie viel wärst du bereit zu zahlen (in €)?",
                placeholder: "Hier eingeben",
                validation: "Bitte gib den Betrag in vollen Euro (ohne Cent) an.",
                reasonLabel: "Begründe deine Entscheidung",
                reasonRequired: "(erforderlich)",
                reasonPlaceholder: "Schreibe hier deine Begründung..."
            },
            result: {
                title: "Deine Entscheidung",
                sellerText: "Du bist bereit, deine Karte für {{price}} € zu verkaufen.",
                buyerText: "Du bist bereit, {{price}} € für die Karte zu zahlen.",
                yourChoicesNone: "Du hast noch keine Entscheidung getroffen."
            },
            resultsGlobal: {
                title: "Endowment-Effekt – Globale Ergebnisse",
                yourClass: "Deine Klasse",
                allClasses: "Alle Klassen (gesamt)",
                buyer: "Käufer:innen (max. Zahlungsbereitschaft)",
                seller: "Verkäufer:innen (mind. Preis)",
                yAxisLabel: "Teilnehmer:innen",
                euro: "€",
                loading: "Lade globale Ergebnisse…"
            },
            explanation: {
                headline: "Der Besitztumseffekt im Alltag",
                imageAlt: "Illustration: Besitztumseffekt",
                sections: [
                    {
                        title: "Der Besitztumseffekt im Alltag",
                        paragraph:
                            "Hast du schon einmal etwas Neues bekommen – vielleicht eine Tasse, ein T‑Shirt oder eine Sammelkarte – und plötzlich gemerkt, dass du sie gar nicht mehr hergeben möchtest? Dann hast du wahrscheinlich den sogenannten Besitztumseffekt erlebt. Er beschreibt, dass wir Dinge, die uns gehören, automatisch als wertvoller empfinden als dieselben Dinge, bevor wir sie besessen haben. Sobald etwas „unseres“ ist, wollen wir es nur ungern wieder abgeben."
                    },
                    {
                        title: "Warum passiert das?",
                        paragraph:
                            "Der Besitztumseffekt zeigt oft, dass Zahlungsbereitschaft und Mindestverkaufspreis für das gleiche Ding nicht übereinstimmen. Ein Grund dafür ist Verlustaversion: Verkaufen fühlt sich wie ein Verlust an und tut emotional weh. Außerdem entwickeln viele Menschen eine emotionale Bindung an ihre Dinge und überschätzen dadurch, was sie verlieren würden."
                    },
                    {
                        title: "Ein bekanntes Experiment (Knetsch)",
                        paragraph:
                            "Jack Knetsch führte ein einfaches Experiment durch: Eine Gruppe bekam eine Tasse, eine andere Gruppe eine Tafel Schokolade. Später konnten die Teilnehmenden tauschen, wenn sie wollten. Dabei zeigte sich, dass die meisten Personen das Objekt, das sie bereits bekommen hatten, auch behalten wollten. Ihr momentaner Besitz (der Referenzpunkt) beeinflusste also, wie sie die Tasse und die Schokolade bewerteten."
                    }
                ],
                experimentNoteTitle: "Unser Experiment",
                experimentNote:
                    "In unserem Versuch untersuchen wir, ob sich der Besitztumseffekt auch in einer einfachen Entscheidungssituation zeigt. Eine Gruppe nennt den Preis, zu dem sie ihre Karte verkaufen würde (Mindestverkaufspreis). Die andere Gruppe nennt, wie viel sie bereit wäre zu zahlen (Zahlungsbereitschaft). Wenn die Verkäufergruppe im Durchschnitt höhere Beträge nennt als die Käufergruppe, deutet das auf einen Besitztumseffekt hin.",
                hint:
                    "Der Besitztumseffekt ist eine Tendenz, kein Gesetz. Wie stark er auftritt, hängt vom Gegenstand, vom Versuchsdesign und von der Erfahrung der Personen ab.",
                sourcesTitle: "Quellen",
                sources: [
                    "Knetsch, J. L. (1989). The Endowment Effect and Evidence of Nonreversible Indifference Curves.",
                    "Kahneman, D., Knetsch, J. L., & Thaler, R. (1990). Experimental tests of the endowment effect and the Coase theorem.",
                    "Ariely, D. (2010). Denken hilft zwar, nützt aber nichts — warum wir immer wieder unvernünftige Entscheidungen treffen."
                ]
            }
        }
    },
    en: {
        title: "My Ticket - Your Price?",
        description:
            "On Lake Constance the Seestadt Soundfestival is coming up. Some people have tickets but cannot attend; others would like to go but have no ticket.",
        screens: {
            seller: {
                title: "You are the seller: you own a ticket",
                text:
                    "A few months ago you bought a ticket for the Seestadt Soundfestival for €80. You cannot attend and want to sell the ticket.",
                inputLabel: "For what price (€) would you sell the ticket?",
                placeholder: "Enter here",
                validation: "Please enter a whole-euro amount (no cents).",
                reasonLabel: "Please explain your choice",
                reasonRequired: "(required)",
                reasonPlaceholder: "Write your explanation here..."
            },
            buyer: {
                title: "You are the buyer: ticket demand",
                text:
                    "Your favorite band plays at the Seestadt Soundfestival. Tickets are sold out. A friend offers a spare ticket for sale.",
                inputLabel: "The ticket cost €80. How much would you be willing to pay (€)?",
                placeholder: "Enter here",
                validation: "Please enter the amount in whole euros (no cents).",
                reasonLabel: "Please explain your choice",
                reasonRequired: "(required)",
                reasonPlaceholder: "Write your explanation here..."
            },
            result: {
                title: "Your decision",
                sellerText: "You are willing to sell your ticket for {{price}} €.",
                buyerText: "You are willing to pay {{price}} € for the ticket.",
                yourChoicesNone: "You have not made a choice yet."
            },
            resultsGlobal: {
                title: "Endowment Effect – Global Results",
                yourClass: "Your class",
                allClasses: "All classes",
                buyer: "Buyer (max. willingness to pay)",
                seller: "Seller (min. accepted price)",
                yAxisLabel: "Participants",
                euro: "€",
                loading: "Loading global results…"
            },
            explanation: {
                headline: "The endowment effect in everyday life",
                imageAlt: "Endowment effect illustration",
                sections: [
                    {
                        title: "Everyday experience",
                        paragraph:
                            "Have you ever gotten something new — maybe a mug, a T‑shirt or a collectible card — and then found you didn't want to give it away? That's probably the endowment effect. Once something is 'ours', we are less willing to give it up."
                    },
                    {
                        title: "Why does it happen?",
                        paragraph:
                            "The endowment effect often means that willingness to pay and minimum selling price do not match. One reason is loss aversion: selling feels like a loss. People also form emotional attachments to their things and tend to overestimate what they would lose."
                    },
                    {
                        title: "A well‑known experiment (Knetsch)",
                        paragraph:
                            "Jack Knetsch ran a simple test: one group got a mug, another got a chocolate bar. Later they could trade if they wanted. It turned out most people kept the item they had received. Their current ownership (the reference point) changed how they valued the mug and the chocolate."
                    }
                ],
                experimentNoteTitle: "Our experiment",
                experimentNote:
                    "In our task we compare sellers (who state a minimum selling price — WTA) and buyers (who state a willingness to pay — WTP). The Seestadt Soundfestival is our example. If sellers name higher amounts on average than buyers, this suggests an endowment effect.",
                hint:
                    "The endowment effect is a tendency, not a rule. Its strength depends on the object, the experimental design and people’s experience.",
                sourcesTitle: "Sources",
                sources: [
                    "Knetsch, J. L. (1989). The Endowment Effect and Evidence of Nonreversible Indifference Curves.",
                    "Kahneman, D., Knetsch, J. L., & Thaler, R. (1990). Experimental tests of the endowment effect and the Coase theorem.",
                    "Ariely, D. (2010). Predictably Irrational."
                ]
            }
        }
    }
};
